import React, { Component } from 'react';

export class Home extends Component {
  static displayName = Home.name;

  render () {
    return (
      
        
            <div class="container">
            
            <div class="text-center my-3"><h1>Apps</h1></div>
                <div class="card-group">
                    <div class="card">
                            <div class="card-body">
                                <h5 class="card-title">IsoNova Tank Wash</h5>
                                <p class="card-text">This app allows users to manage tank wash invoices/master bills for the IsoNova account.</p>
                            </div>
                            <div class="card-footer">
                            <a href="/isonova" class="btn btn-primary stretched-link">Open</a>
                            </div>
                    </div>
                        <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">Driver Call Log</h5>
                                    <p class="card-text">This app allows users to view driver profiles. Coming Soon!</p>
                                </div>
                                <div class="card-footer">
                            <a href="/" class="btn btn-primary stretched-link">Open</a>
                                </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Special Ops Tactical</h5>
                            <p class="card-text">View/Update Spec Ops driver attendance, gaps in coverage, etc.</p>
                        </div>
                        <div class="card-footer">
                            <a href="/sot/list" class="btn btn-primary stretched-link">Open</a>
                        </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title">Driver Status Update</h5>
                        <p class="card-text">Put drivers off duty</p>
                    </div>
                    <div class="card-footer">
                        <a href="/driverstatus" class="btn btn-primary stretched-link">Open</a>
                    </div>
                </div>
                </div>
            </div>
    );
  }
}
